import React from 'react';
import './Wiki.css';

// Cells of the priority toggle of a wiki entry (CustomComboBox): index 0 = normal (priority 1),
// index 1 = wichtig (priority 2). Returned as an array so CustomComboBox (React.Children.map) gets two cells.
export function wikiPriorityOptions() {
  return [
    <span key="normal" className="wikiPriorityOption">Normal</span>,
    <span key="important" className="wikiPriorityOption">
      <span className="material-symbols-rounded" aria-hidden="true">priority_high</span>
      Wichtig
    </span>,
  ];
}
